import permissions from "app/permissions";
import { getPermissions } from "auth/security/securityUtils";
import {
  Datagrid,
  DateField,
  EditButton,
  FunctionField,
  List,
  ListActions,
  ReferenceField,
  ShowButton,
  TextField,
  Title,
  useStore,
  SimpleList,
} from "react-admin";
import { checkPermission } from "server/security/utils";
import { Box, Paper, Typography, useMediaQuery } from "@mui/material";
import { MOBILE_BREAKPOINT } from "utils/constants";
import { settings } from "app";
import { MobileListRow } from "features/MobileListRow";
import SecuredComponent from "server/security/SecuredComponent";
import CustomFilter from "features/CustomFilter";
import useSemesterFilter from "features/filters/useSemesterFilter";
import { studentRequests } from "api/studentApi";

const STORE_KEY = "scholarshipCampaigns.filters";

const ListScholarshipCampaigns = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  const [filters, setFilters] = useStore(STORE_KEY, null);
  const semester = useSemesterFilter({ filters });

  const handleSearch = selectedFilters => {
    setFilters(selectedFilters);
  };

  return (
    <>
      {!filters && <Title title={"Кампании стипендии"} />}
      <CustomFilter
        title="Избери филтри"
        cardWidth={isMobile ? "100%" : "700px"}
        filters={semester.fields}
        buttonLabel="Покажи"
        buttonDisabled={!semester.isComplete}
        buttonOnClick={() => handleSearch(semester.query)}
      />
      {!filters ? (
        <Paper sx={{ mt: 5 }}>
          <Box
            p={2}
            sx={{ display: "flex", justifyContent: "center", gap: 3 }}
          >
            <Typography
              align="center"
              color="secondary"
            >
              Въведи филтри за кампании стипендии.
            </Typography>
          </Box>
        </Paper>
      ) : (
        <List
          exporter={false}
          title="Кампании за стипендии"
          filter={filters}
          actions={
            <ListActions hasCreate={checkPermission(getPermissions(), permissions.canCreateScholarshipCampaigns)} />
          }
        >
          {isMobile ? (
            <SimpleList
              linkType={false}
              sx={settings.style.mobileList}
              primaryText={record => <MobileListRow fields={[{ label: "Име", value: record?.nameBg }]} />}
              secondaryText={record => (
                <div>
                  <MobileListRow
                    fields={[
                      {
                        label: "Учебна година",
                        value: (
                          <ReferenceField
                            source="academicYearId"
                            reference={studentRequests.getAcademicYearsSelect()}
                          >
                            <TextField source="name" />
                          </ReferenceField>
                        ),
                      },
                    ]}
                  />
                  <MobileListRow
                    fields={[
                      {
                        label: "Семестър",
                        value: (
                          <ReferenceField
                            source="sessionType"
                            reference={studentRequests.getAcademicSessionTypesSelect()}
                          >
                            <TextField source="name" />
                          </ReferenceField>
                        ),
                      },
                    ]}
                  />
                  <MobileListRow
                    fields={[
                      {
                        label: "Начална дата кандидатстване",
                        value: (
                          <DateField
                            source="applicationStartDate"
                            locales="bg-BG"
                          />
                        ),
                      },
                      {
                        label: "Крайна дата кандидатстване",
                        value: (
                          <DateField
                            source="applicationEndDate"
                            locales="bg-BG"
                          />
                        ),
                      },
                    ]}
                  />
                  <MobileListRow
                    fields={[
                      {
                        label: "Активност",
                        value: (
                          <Typography
                            fontSize={14}
                            color={record?.isFinished ? "error" : theme => theme.palette.success.main}
                          >
                            {record?.isFinished ? "Приключена" : "Активна"}
                          </Typography>
                        ),
                      },
                    ]}
                  />
                </div>
              )}
              tertiaryText={() => (
                <>
                  <SecuredComponent permission={permissions.canUpdateScholarshipCampaigns}>
                    <EditButton label="" />
                  </SecuredComponent>
                  <SecuredComponent permission={permissions.canPreviewScholarshipCampaigns}>
                    <ShowButton label="" />
                  </SecuredComponent>
                </>
              )}
            />
          ) : (
            <Datagrid
              bulkActionButtons={false}
              rowClick={false}
            >
              <TextField
                source="nameBg"
                label="Име"
                sortable={false}
              />
              <ReferenceField
                source="academicYearId"
                reference={studentRequests.getAcademicYearsSelect()}
                label="Учебна година"
                sortable={false}
              >
                <TextField source="name" />
              </ReferenceField>
              <ReferenceField
                source="sessionType"
                reference={studentRequests.getAcademicSessionTypesSelect()}
                label="Семестър"
                sortable={false}
              >
                <TextField source="name" />
              </ReferenceField>
              <DateField
                source="applicationStartDate"
                label="Начална дата кандидатстване"
                sortable={false}
                locales="bg-BG"
              />
              <DateField
                source="applicationEndDate"
                label="Крайна дата кандидатстване"
                sortable={false}
                locales="bg-BG"
              />
              <FunctionField
                label="Активност"
                render={record => (
                  <Typography
                    fontSize={14}
                    color={record?.isFinished ? "error" : theme => theme.palette.success.main}
                  >
                    {record?.isFinished ? "Приключена" : "Активна"}
                  </Typography>
                )}
              />
              <SecuredComponent permission={permissions.canUpdateScholarshipCampaigns}>
                <EditButton />
              </SecuredComponent>
              <SecuredComponent permission={permissions.canPreviewScholarshipCampaigns}>
                <ShowButton />
              </SecuredComponent>
            </Datagrid>
          )}
        </List>
      )}
    </>
  );
};

export default ListScholarshipCampaigns;
